import { produce } from 'immer';
import { getType } from 'typesafe-actions';

import { educationModuleActions, type EducationModuleActions } from './actions';

import type EducationVideo from '../../types/EducationModule/EducationVideo';

interface State {
  educationVideos: EducationVideo[];
  educationVideo: EducationVideo | null;
  spinner: boolean;
  hasLoaded: boolean;
}

const initialState: State = {
  educationVideos: [],
  educationVideo: null,
  spinner: false,
  hasLoaded: false
};

const educationModuleReducer = (state = initialState, action: EducationModuleActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(educationModuleActions.saveEducationVideos): {
        draft.educationVideos = action.payload;
        draft.hasLoaded = true;
        return;
      }
      case getType(educationModuleActions.removeEducationVideo): {
        const index = state.educationVideos.findIndex(v => v.id === action.payload);
        if (index !== -1) {
          draft.educationVideos.splice(index, 1);
        }
        return;
      }
      case getType(educationModuleActions.setEducationVideo): {
        draft.educationVideo = action.payload;
        return;
      }
      case getType(educationModuleActions.setEducationModuleSpinner): {
        draft.spinner = action.payload;
        return;
      }
    }
  });

export default educationModuleReducer;
